import { modifier } from 'ember-modifier';

export default modifier((_element: HTMLElement, [action]: [(event: PointerEvent) => void]) => {
  document.addEventListener('click', action);

  return () => {
    document.removeEventListener('click', action);
  };
});
